import {gql} from "graphql-tag";
import {basePageableGraphqlField, responseField} from "../../../base.graphql";
import {warehouseFields} from "../warehouse/warehouse.graphql";

// Define fields for building
export const buildingFields = `
      id
      name
      size
      zones
      warehouse{
      ${warehouseFields}
      }
      isActive`;


export const warehouseBuilding =`
      id
      uniqueId
      name
      description
      totalCapacity
      numberOfZones
      isActive
      createdDate
`;

// Queries

export const GET_WAREHOUSE_BUILDINGS = gql`
  query getWarehouseBuildings ($filtering:WarehouseBuildingFilteringInputObject){
    getWarehouseBuildings(filtering: $filtering) {
        response {
                ${responseField}
            }
        data {
           ${warehouseBuilding}
        }
        page {
           ${basePageableGraphqlField}
        }
    }
}
`;
export const GET_BUILDING_DATA = gql`
    query getBuildingData($filtering: BuildingProfileInputFilteringObject) {
        getBuildingData(filtering: $filtering) {
            response {
                ${responseField}
            }
            data {
                ${buildingFields}
            }
        }
    }`;

export const GET_BUILDING_DETAILS = gql`
    query getBuildingDetails($id: ID!) {
        getBuildingDetails(id: $id) {
            response {
                ${responseField}
            }
            data {
                ${buildingFields}
            }
        }
    }`;

export const GET_BUILDING_DASHBOARD = gql`
    query getBuildingDashboard($filtering: BuildingDashboardFilteringObject) {
        getBuildingDashboard(filtering: $filtering) {
            response {
                ${responseField}
            }
            data {
                totalBuildings
                activeBuildings
                inactiveBuildings
                buildingData {
                    ${buildingFields}
                }
            }
        }
    }`;

// Mutations

export const REGISTER_WAREHOUSE_BUILDING_MUTATION = gql`
    mutation RegisterWarehouseBuildingsMutation($input: WarehouseBuildingInputObject!) {
    registerWarehouseBuildingsMutation(input: $input) {
        response{
            ${responseField}
        }

  
        data {
            ${warehouseBuilding}
        }
    }
}
`;

export const UPDATE_WAREHOUSE_BUILDING_MUTATION = gql`
    mutation UpdateWarehouseBuildingsMutation($input: WarehouseBuildingInputObject!) {
        updateWarehouseBuildingsMutation(input: $input) {
            response{
                ${responseField}
            }
      
        data {
            ${warehouseBuilding}
        }
    }
}
`;



export const UPDATE_BUILDING_MUTATION = gql`
    mutation updateBuildingMutation($input: BuildingInputObject!) {
        updateBuildingMutation(input: $input) {
            response {
                ${responseField}
            }
            data {
                ${buildingFields}
            }
        }
    }`;

export const DELETE_WAREHOUSE_BUILDING_MUTATION = gql`
    mutation DeleteWarehouseBuildingsMutation($uniqueId:String!) {
        deleteWarehouseBuildingsMutation(uniqueId: $uniqueId) {
        response{${responseField}}
    }
}
`;

export const DELETE_BUILDING_DATA = gql`
    mutation deleteBuildingData($id: ID!) {
        deleteBuildingData(id: $id) {
            response {
                ${responseField}
            }
        }
    }`;